<template>
    <button
        class="kgr-table__action"
        :disabled="disabled"
        style="position: relative;"
        @click="$emit('sendChargeback')"
    >
        <kgr-icon
            icon-class="email"
            :title="title"
            :disabled="disabled"
            :style="disabled ? {} : { color: '#2196f3' }"
        />
        <i
            v-if="emailPrepared"
            class="kgr-indicator is-success dot"
            :class="emailSent ? 'finished' : 'running'"
        >
        </i>
    </button>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon
    },
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
    },
    computed: {
        emailPrepared() {
            return this.invoice.chargeback.pdfLastSentAsEmail !== null;
        },
        emailSent() {
            return this.invoice.chargeback.pdfLastSentAsEmailFinished;
        },
        title() {
            if (this.invoice.invoiceRecipient.email === null) {
                return this.$t('Keine E-Mail-Adresse hinterlegt');
            }
            if (!this.invoice.chargeback.pdfExists) {
                return this.$t('Das PDF wird erstellt');
            }
            if (this.invoice.chargeback.pdfLastSentAsEmail !== null && !this.invoice.chargeback.pdfLastSentAsEmailFinished) {
                return this.$t('Das PDF wird gerade verschickt.')
            }
            return this.invoice.chargeback.pdfLastSentAsEmail
                ? 'Rücklastschrift als E-Mail verschicken\n\nLetztes Mal verschickt am ' + this.formatDate(this.invoice.chargeback.pdfLastSentAsEmail)
                : this.$t('Rücklastschrift als E-Mail verschicken')
        },
        disabled() {
            return this.invoice.invoiceRecipient.email === null || this.invoice.chargeback.pdfExists === false;
        },
    },
    methods: {
        formatDate(date) {
            return new Helper().formatDate(date);
        },
    },
}
</script>
<style>
div.pdf-email-icon {
    margin-right: 15px;
}
.dot {
    height: 7px;
    width: 7px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
}
.finished {
    background-color: #00ff00;
}
.running {
    background-color: #afafaf;
}
</style>
